import { createStyles, makeStyles } from "@material-ui/core";
import React from "react";
import { FileWithPreview } from "react-dropzone";
import { ApiResponse } from "../../api/CustomFetch";
import { getWrittenExamScoreImportUrl } from "../../api/rtk/ExamSessionApi";
import { ExamScoreResultModel } from "../../model/ExamScoreResultModel";
import CustomDraggableDialog from "../common/customDialog/CustomDraggableDialog";
import UploadDropZone from "../common/UploadDropZone";
import TranslatedMessage from "../translations/TranslatedMessage";

interface ImportWrittenExamScoresDialogProps {
  examSessionId: string;
  isOpen: boolean;
  onUploadError: () => void;
  onFileUploaded: (file: FileWithPreview, response: ApiResponse<ExamScoreResultModel>) => void;
  onClose: () => void;
}

const useStyles = makeStyles(() =>
  createStyles({
    dropZoneDiv: { width: "100%", marginLeft: "auto", marginRight: "auto" },
  })
);

const ImportScoresAndGradesExamDialog: React.FunctionComponent<ImportWrittenExamScoresDialogProps> = ({
  examSessionId,
  isOpen,
  onFileUploaded,
  onUploadError,
  onClose,
}) => {
  const classes = useStyles({});

  return (
    <CustomDraggableDialog
      hideActions={true}
      onClose={onClose}
      acceptText={<TranslatedMessage id="common.accept" />}
      cancelText={<TranslatedMessage id="common.cancel" />}
      content={
        <React.Fragment>
          <div className={classes.dropZoneDiv}>
            <UploadDropZone
              accept=".csv"
              onUploadError={onUploadError}
              onFileUploaded={onFileUploaded}
              uploadURL={getWrittenExamScoreImportUrl(examSessionId)}
            />
          </div>
        </React.Fragment>
      }
      isOpen={isOpen}
      title={<TranslatedMessage id="examSession.button.importExamScoresAndGrades" />}
    />
  );
};

export default ImportScoresAndGradesExamDialog;
